"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Check = function (_a) {
    var _b = _a.scale, scale = _b === void 0 ? 1 : _b, _c = _a.color, color = _c === void 0 ? '#23806C' : _c;
    return (react_1.default.createElement("svg", { width: scale * 16, height: scale * 12, viewBox: "0 0 16 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.083 8.583L14.353 0 16 1.709 6.083 12 0 5.688l1.646-1.709 4.437 4.604z", fill: color })));
};
exports.default = Check;
//# sourceMappingURL=NewCheck.js.map